import { Injectable } from '@angular/core';

import { RedirectCommand, RedirectStrategy, RedirectStrategyContext } from '@guardfinder/shared';

import { RedirectStrategies } from './redirect-strategies';

export interface AppInitRedirectStrategyContext extends RedirectStrategyContext {
    isProLoggedIn: boolean;
}

@Injectable()
export class AppInitRedirectStrategy implements RedirectStrategy<AppInitRedirectStrategyContext> {
    private readonly welcomeScreenRedirectCommand: RedirectCommand = { path: '/welcome' };
    private readonly dashboardRedirectCommand: RedirectCommand = { path: '' };

    async execute(context: AppInitRedirectStrategyContext): Promise<RedirectCommand> {
        if (!context) {
            throw new Error('AppInit requires isProLoggedIn context');
        }
        return context.isProLoggedIn ? this.dashboardRedirectCommand : this.welcomeScreenRedirectCommand;
    }

    strategyName(): string {
        return RedirectStrategies.APP_INIT;
    }
}
